import { QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { createQueryClient } from "@/lib/api/query-client";

export function QueryProvider({ children }: { children: ReactNode }) {
  // Lazily create so HMR doesn't reinitialise across renders.
  const [client] = useState(() => createQueryClient());
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
